import React, { useState } from 'react';
import Select from 'react-select';
import findIndex from 'lodash/findIndex';
import { THEMES } from '../../constants/config';
import { TargetNode } from '../../models/TargetNode';

interface ThemeOption {
  value: number;
  label: string;
  [key: string]: any;   // THEMES rows also carry iconPrefix/min/max/votingScale
}

interface ThemeSelectorProps {
  // Plain target node (the `TargetNode` model lands with the container in
  // Phase 7). Only extra.c.c42 is read.
  node?: TargetNode;
  className?: string;
  onChangeTheme: (option: ThemeOption | null) => void;
}

// NOTE: the selection is seeded from the node in a useState INITIALIZER, so it
// only re-reads when the component mounts. That is load-bearing today: the
// editor unmounts and remounts whenever isTargetLoading flips, which is what
// makes it pick up a newly loaded target. See the same pattern — and its
// downside — in PreviousSelector.
const ThemeSelector = ({ node, className, onChangeTheme }: ThemeSelectorProps) => {
  const [selectedOption, setSelectedOption] = useState<ThemeOption | null>(() => {
    const themeId = node?.extra?.c?.c42;
    if (typeof themeId === 'number') {
      const index = findIndex(THEMES, { value: themeId });
      return index >= 0 ? THEMES[index] : null;
    }
    return null;
  });

  const themeName = () => {
    const index = selectedOption
      ? findIndex(THEMES, { value: selectedOption.value })
      : -1;
    return index >= 0 ? THEMES[index].label : 'SELECT...';
  };

  const handleChange = (option: ThemeOption | null) => {
    setSelectedOption(option);
    onChangeTheme(option); // Hack to update parent
  };

  return (
    <div className={className}>
      <Select
        className={'theme-selector'}
        value={selectedOption}
        placeholder={themeName()}
        onChange={handleChange}
        options={THEMES}
      />
    </div>
  );
};

export default React.memo(ThemeSelector);
